import { useEffect, useCallback } from "react";
import { API_OPTIONS } from "../utils/constants";
import { addTrailerVideo } from "../utils/moviesSlice";
import { useDispatch } from "react-redux";

const useMovieTrailer = (movieId) => {
  const dispatch = useDispatch();

  const getTrailerVideo = useCallback(async () => {
    if (!movieId) return;

    const data = await fetch(
      "https://api.themoviedb.org/3/movie/" + movieId + "/videos?language=en-US",
      API_OPTIONS
    );
    const json = await data.json();

    const filterData = json.results.filter(
      (video) => video.type === "Trailer"
    );
    const trailer = filterData.length
      ? filterData[0]
      : json.results[0];

    dispatch(addTrailerVideo(trailer));
  }, [dispatch, movieId]);

  useEffect(() => {
    getTrailerVideo();
  }, [getTrailerVideo]);
};

export default useMovieTrailer;
